// extracted by mini-css-extract-plugin
export default {"container":"planDetail_container__QmA5b"};